import {
  MenuItem,
  Select,
  FormControl,
  InputLabel,
  SelectChangeEvent,
} from '@mui/material';

interface TypeRecord {
  value: string | number;
  label: string;
}

interface InputFilterProps {
  label: string;
  options: TypeRecord[];
  value: string | number;
  onChange: (value: string | number) => void;
}

const InputFilter = ({ label, options, value, onChange }: InputFilterProps) => {
  const handleSelectChange = (event: SelectChangeEvent<string | number>) => {
    onChange(event.target.value);
  };

  return (
    <FormControl fullWidth>
      <InputLabel
        sx={{
          height: 40,
          fontSize: '14px',
          lineHeight: 'normal',
          transform: 'translate(14px, 0)',
          paddingLeft: '10px',
          transition: 'all 0.2s ease',
          display: 'flex',
          alignItems: 'center',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(20px, -16px) scale(0.75)', // Ajuste para subir mais
            paddingLeft: '10px',
            lineHeight: 'normal',
          },
        }}
      >
        {label}
      </InputLabel>

      <Select
        sx={{
          height: 40,
          fontSize: '14px',
          lineHeight: 'normal',
          transform: 'translate(14px, 0)',
          transition: 'all 0.2s ease',
          display: 'flex',
          alignItems: 'center',
          '&.MuiInputLabel-shrink': {
            transform: 'translate(20px, -16px) scale(0.75)', // Ajuste para manter alinhado
            lineHeight: 'normal',
          },
        }}
        value={value}
        onChange={handleSelectChange}
        label={label}
      >
        {options.map((option) => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default InputFilter;
